import { render, staticRenderFns } from "./formFillupStudentDetails.vue?vue&type=template&id=83aa7a98&"
import script from "./formFillupStudentDetails.vue?vue&type=script&lang=js&"
export * from "./formFillupStudentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports